import React from 'react'
import { useMediaQuery } from '@/hooks/useMediaQuery'

interface Props {
  content: React.ReactNode[]
  onClick: () => void
}

const SearchResultItem: React.FC<Props> = ({ content, onClick }) => {
  const mobileCheck = useMediaQuery('(max-width: 640px)')

  return (
    <li
      onClick={onClick}
      className={`hover:bg-primary-hover ${mobileCheck ? 'text-base' : 'text-xl'} px-[2.63rem] py-[0.4rem] rounded-lg cursor-pointer`}
    >
      {content.map((line, i) => (
        <div key={i}>{line}</div>
      ))}
    </li>
  )
}

export default SearchResultItem
